import { useTranslation } from '@flex-packages/i18n';
import { trans } from '@flex-packages/i18n-base';
import {
  WorkExperienceCompanyNameInput,
  WorkExperienceStatusSelect,
} from '@flex-private-packages/recruiting-common/components';
import { Controller } from 'react-hook-form';

import type { JobDescriptionFormState } from '../../../../models';

interface Props {
  currentIndex: number;
  required: boolean;
}

export function WorkExperienceCompanyNameAndStatusFormItem({
  currentIndex,
  required,
}: Props) {
  const { t } = useTranslation();

  return (
    <Controller<
      JobDescriptionFormState,
      `workExperienceBackgrounds.${typeof currentIndex}.name`
    >
      name={`workExperienceBackgrounds.${currentIndex}.name`}
      rules={{
        required: required
          ? t(trans('recruiting.work_experience.retirement_date.placeholder'))
          : false,
      }}
      render={({ field: nameField, fieldState: { error: nameError } }) => (
        <Controller<
          JobDescriptionFormState,
          `workExperienceBackgrounds.${typeof currentIndex}.workExperienceStatus`
        >
          name={`workExperienceBackgrounds.${currentIndex}.workExperienceStatus`}
          rules={{
            required: required
              ? t(
                  trans(
                    'recruiting.work_experience.status.edit.helper.required'
                  )
                )
              : false,
          }}
          render={({
            field: {
              onChange: onWorkExperienceStatusTypeChange,
              ...selectField
            },
            fieldState: { error: workExperienceStatusTypeError },
          }) => {
            const errorState =
              nameError || workExperienceStatusTypeError ? 'error' : 'default';
            const helperText =
              nameError?.message ?? workExperienceStatusTypeError?.message;

            return (
              <WorkExperienceCompanyNameInput
                required={required}
                state={errorState}
                helperText={helperText}
                {...nameField}
              >
                <WorkExperienceStatusSelect
                  onValueChange={onWorkExperienceStatusTypeChange}
                  {...selectField}
                />
              </WorkExperienceCompanyNameInput>
            );
          }}
        />
      )}
    />
  );
}
